import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import { ChartWorkbenchLauncherProvider } from '../navbar/top/ChartWorkbenchLauncher';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import AppBrandFooter from './AppBrandFooter';
import AppScrollArea from './AppScrollArea';

/** 工作台列表（手机端仍 passthrough 全屏；桌面走分卡片 + 页面滚动） */
const WORKBENCH_SHELL_PATHS = new Set([
	'/productlist',
	'/customerlist',
	'/orderlist',
	'/editlist',
	'/userlist',
	'/admin/loginlogs',
	'/approval/list',
]);

export function isDashboardHomePath(pathname) {
	return pathname === '/dashboard' || pathname === '/demo/dashboard';
}

export function isWorkbenchShellPath(pathname) {
	return WORKBENCH_SHELL_PATHS.has(pathname);
}

export function isAppMainShellPassthrough(pathname, { isMobile = false } = {}) {
	if (isDashboardHomePath(pathname)) return true;
	return isMobile && isWorkbenchShellPath(pathname);
}

/**
 * 已登录页主内容壳：
 * - 桌面首页：通栏 Header（Logo+搜索同一条）+ 下方侧栏 QuickLinks | 主区
 * - 手机工作台：passthrough 全屏
 * - 桌面工作台 / 其它工作页：顶栏 + 主区滚动（glass 下透）
 */
const AppMainShell = ({ children }) => {
	const { pathname } = useLocation();
	const { breakpoints } = useBreakpoints();
	const isMobile = breakpoints.down('md');
	const isDashboardHome = isDashboardHomePath(pathname);
	const passthrough = isAppMainShellPassthrough(pathname, { isMobile });

	const shell = passthrough ? (
		<div
			className={classNames('app-main-shell app-main-shell--passthrough', {
				'app-main-shell--home-l': isDashboardHome,
			})}
		>
			<Header />
			{children}
		</div>
	) : (
		<div className='app-main-shell app-main-scroll-layout'>
			<Header />
			<AppScrollArea className='app-main-scroll' maxHeight='100%' fillViewport highlightOnScroll style={{ flex: '1 1 auto', minHeight: 0 }}>
				{/* SimpleBar 会内联 padding:0，不能靠 CSS padding-top 顶开 */}
				<div className='app-main-scroll-nav-spacer' aria-hidden='true' />
				{children}
				<AppBrandFooter />
				<div className='app-main-scroll-end-spacer' aria-hidden='true' />
			</AppScrollArea>
		</div>
	);

	return <ChartWorkbenchLauncherProvider>{shell}</ChartWorkbenchLauncherProvider>;
};

AppMainShell.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AppMainShell;
